let lastGlsResponseJackpotMode: boolean | undefined;

export const recordGlsResponseJackpotMode = (
  jackpotMode: boolean | undefined,
): void => {
  lastGlsResponseJackpotMode = jackpotMode;
};

export const getLastGlsResponseJackpotMode = (): boolean | undefined =>
  lastGlsResponseJackpotMode;

export const clearGlsResponseJackpotMode = (): void => {
  lastGlsResponseJackpotMode = undefined;
};

/** @internal test helper */
export const resetLaunchedJackpotModeTracker = (): void => {
  clearGlsResponseJackpotMode();
};
